// extracted by mini-css-extract-plugin
module.exports = {"container":"cd01fbf7b5--container--Qo8Zu","image":"cd01fbf7b5--image--Ssr5U","title":"cd01fbf7b5--title--VPU00","link":"cd01fbf7b5--link--h15A8"};